import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-test": "lifetime-stats",
  "data-tour": "customer-lifetime",
  class: "lifetime-tiles"
}

import { computed } from 'vue'

import StatTile from '@/components/customers/record/StatTile.vue'
import { lifetimeTiles } from '@/composables/useCustomerLifetimeStats'


export default {
  __name: 'CustomerLifetimeStats',
  props: {
  state: { type: String, required: true },
  lifetime: { type: Object, default: null }
},
  setup(__props) {

const props = __props

const tiles = computed(() => lifetimeTiles(props.lifetime))

return (_ctx, _cache) => {
  return (__props.state !== 'error')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiles.value, (tile) => {
          return (_openBlock(), _createBlock(StatTile, {
            key: tile.label,
            class: "lifetime-tile",
            label: tile.label,
            value: tile.value,
            caption: tile.caption,
            compact: Boolean(tile.compact),
            loading: __props.state === 'loading'
          }, null, 8, ["label", "value", "caption", "compact", "loading"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

}